import $ from 'jquery';
import 'bootstrap';

import {formatMoney} from '@shopify/theme-currency';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import '../vendor/lazysizes/plugins/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes';
import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';

import 'slick-carousel/slick/slick';
import "slick-carousel/slick/slick.scss";
import "../../styles/theme.scss";
import "../../styles/theme.scss.liquid";

import {datepicker} from '../vendor/datepicker/js/bootstrap-datepicker.js';
import '../vendor/datepicker/css/bootstrap-datepicker.css';

import '../vendor/fontawesome/js/all.js';

//import "hamburgers/_sass/hamburgers/hamburgers.scss";
import "hover.css/scss/hover.scss";
import "animate.css/animate.css";

import * as ScrollMagic from "scrollmagic";

// Common a11y fixes
focusHash();
bindInPageLinks();

// Set up jQuery so that it can be accessed from the HTML
window.jQuery = $;
window.$ = $;
// cookiesEnabled was removed from the latest version of theme-scripts cart.js
// https://github.com/Shopify/starter-theme/issues/112
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace(
                                                                                  'supports-no-cookies',
                                                                                  'supports-cookies',
                                                                                  );
}






var pdp_slider = $('.product-image').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  swipeToSlide: false,
  swipe: false,
  responsive: [{
    breakpoint: 768,
    settings: {
      slidesToShow:1,
      autoplay: false,
      slidesToScroll: 1,
    }
  }]
});



$('.pdp_thumb_link').click(function(event) {
  event.preventDefault();
  $('.product-image').slick('slickGoTo',$(this).attr('data-index'));
});
$('#mobile_search_link').click(function(event) {
 event.preventDefault();
 bcsffilter.openSuggestionMobile('#bc-sf-search-box-1');
});




$('.hamburger').click(function(event) {
  var is_collapsed = $(this).hasClass('collapsed');
  if (is_collapsed) {
    var doc_height = $(document).height();
    var header_height = $('#mobile_navbar_wrapper').height();
    $('.mobile_nav .navbar-collapse').css('top', header_height);
    $('.mobile_nav .navbar-collapse').css('min-height', doc_height);
    $('body').addClass('mobile_nav-is-active');
    $(this).addClass('is-active');
  } else {
    $('.mobile_nav .navbar-collapse').css('min-height', '100vh');
    $('body').removeClass('mobile_nav-is-active');
    $(this).removeClass('is-active');
    $('.mobile_level_1').attr('style', '');
    $('.mobile_level_1').removeClass('level_1_open');
    $('.dropdown-submenu .show').removeClass("show");
  }
});

const $dropdown = $(".dropdown");
const $dropdownToggle = $(".dropdown-toggle");
const $dropdownMenu = $(".dropdown-menu");
const showClass = "show";

$(window).on("load resize", function() {
  if (this.matchMedia("(min-width: 992px)").matches) {
    $dropdown.hover(
                    function() {
                      const $this = $(this);
                      $this.addClass(showClass);
                      $this.find($dropdownToggle).attr("aria-expanded", "true");
                      $this.find($dropdownMenu).addClass(showClass);
                    },
                    function() {
                      const $this = $(this);
                      $this.removeClass(showClass);
                      $this.find($dropdownToggle).attr("aria-expanded", "false");
                      $this.find($dropdownMenu).removeClass(showClass);
                    }
                    );
  } else {
    $dropdown.off("mouseenter mouseleave");
  }
});



  // ------------------------------------------------------- //
  // Multi Level dropdowns
  // ------------------------------------------------------ //


  $('.mobile_level_1.mobile_dropdown_link').click(function(event) {
    event.preventDefault();
    if ($(this).hasClass('level_1_open')) {
      $('.mobile_level_1').attr('style', '');
      $('.mobile_level_1').removeClass('level_1_open');
      //console.log('a');
    } else {
      $('.mobile_level_1').attr('style', 'display: none !important');
      $(this).addClass('level_1_open');
      $('.level_1_open').attr('style', '');
     // console.log('b');
    }
  });
  $("ul.dropdown-menu [data-toggle='dropdown']").on("click", function(event) {
    event.preventDefault();
    event.stopPropagation();

    $(this).siblings().toggleClass("show");
    $(this).toggleClass("show");
    if (!$(this).next().hasClass('show')) {
      $('.mobile_level_1.level_1_open').attr('style', '');
      $('.mobile_nav_level2_link').attr('style', '');
      $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
      //console.log('aa');
    } else {
      $('.mobile_nav_level2_link:not(.show)').attr('style', 'display: none !important');
      $('.mobile_level_1').attr('style', 'display: none !important');
     // console.log('bb');
    }
    $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
     $('.dropdown-submenu .show').removeClass("show");
   //  console.log('cc');
   });

  });


  var delay = 0;
  var image_slideshows = $('.image_grid_slideshow_wrapper');
  $.each(image_slideshows , function(index, val){
    setTimeout(function(){
     $(val).slick({
      infinite:true,
      slidesToShow: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2400,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });
   }, index * 1100);

  });


  $('.blog_feed_slide_wrapper').each(function(index, el) {
    var working_id = $(el).attr('data-block_id');
    $('#blog_feed_slider_' + working_id).slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.carousel_btn_' + working_id + '.carousel-prev'),
      nextArrow: $('.carousel_btn_' + working_id + '.carousel-next'),
      responsive: [
      {
        breakpoint: 900,
        settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        autoplay:true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
  });

  });



  $('.featured_collection_slide_wrapper').each(function(index, el) {
    var working_id = $(el).attr('data-block_id');
    $('#featured_collection_slider_' + working_id).slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.carousel_btn_' + working_id + '.carousel-prev'),
      nextArrow: $('.carousel_btn_' + working_id + '.carousel-next'),
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow:2,
          slidesToScroll: 2,
        }
      }]
    });
  });




  $('.featured_content_slide_wrapper').each(function(index, el) {
    var working_id = $(el).attr('data-block_id');
    $('#featured_content_slider_' + working_id).slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.carousel_btn_' + working_id + '.carousel-prev'),
      nextArrow: $('.carousel_btn_' + working_id + '.carousel-next'),
      responsive: [{
        breakpoint: 768,
        settings: {
          arrows: false,
          autoplay: true,
          autoplaySpeed: 1500,
          pauseOnHover: true,
          pauseOnFocus: true,
          slidesToShow:2,
          slidesToScroll: 1,
        }
      }]

    });
  });


  $('.review_block_slide_wrapper').each(function(index, el) {
    var working_id = $(el).attr('data-block_id');
    $('#review_block_slider_' + working_id).slick({
      infinite: true,
      slidesToShow: 3,
      adaptiveHeight: true,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.carousel_btn_' + working_id + '.carousel-prev'),
      nextArrow: $('.carousel_btn_' + working_id + '.carousel-next'),
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1,
        }
      }]
    });
  });





  $('.blog_filter_select').change(function(event) {
    /* Act on the event */
    event.preventDefault();
    var selected_filter = $(this).children('option:selected').val();
    location = selected_filter;

  });


  $('.icon_carousel_wrapper').each(function(index, el) {
    var card_count = $(el).children('.card').length;
    var item_count = 5;
    var mobile_item_count = 3;

    if (card_count <= 5) {
      item_count = card_count - 1;
    }

    if (card_count <= 3) {
      mobile_item_count = card_count - 1;
    }
    var working_id = $(el).attr('data-block_id');
    $('#icon_carousel_slider_' + working_id).slick({
      infinite: true,
      centerMode: true,
      centerPadding: 0,
      focusOnSelect: true,
      slidesToShow: item_count,
      arrows: true,
      variableWidth: true,
      prevArrow: $('.carousel_btn_' + working_id + '.carousel-prev'),
      nextArrow: $('.carousel_btn_' + working_id + '.carousel-next'),
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1,
        }
      }]
    });

    $('#icon_carousel_slider_' + working_id).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var NextSlideDom=$(slick.$slides.get(nextSlide));
      var curr_slide_image = $(NextSlideDom).find('img')
      $('#carousel_slide_info_' + working_id).attr('href', curr_slide_image.attr('data-url'));
      $('#carousel_slide_info_' + working_id).text(curr_slide_image.attr('data-title'));
    });



  });

  $('.page_hero_down').click(function(event) {
    event.preventDefault();
    var parent = $(this).closest('.page_builder_page_hero');
    var position = parent.position().top + parent.height()
    window.scroll({
      top: position,
      left: 0,
      behavior: 'smooth'
    });
  });





  $('.video_poster_wrapper').click(function(event) {
    event.preventDefault();
    $(this).hide();
  });

  $(window).on("load scroll", function() {
    check_animation();
  });


  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(elem).offset().top;

    if ($(elem).height() <= 150) {
      var elemBottom = elemTop + $(elem).height()/2;
    } else {
      var elemBottom = elemTop + 150;
    }
    //var elemBottom = elemTop + $(elem).height();
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }




  function check_animation() {
    $('.animated_section_title').each(function() {
      if (isScrolledIntoView(this) === true) {
        $(this).addClass('animate__fadeInDown');
      }
    });
    $('.animated_fade_in').each(function() {
      if (isScrolledIntoView(this) === true) {
        $(this).addClass('animate__fadeIn');
      }
    });
    $('.page_template_content img').each(function() {
      if (isScrolledIntoView(this) === true) {
        $(this).addClass('animate__fadeIn animate__animated');
      }
    });
  }
